var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.notHomePage)?[_c('HomeHeader'),_c('v-navigation-drawer',{attrs:{"fixed":"","temporary":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}})]:_vm._e(),_c('v-main',[_c('v-container',{staticClass:"px-4 py-2 fill-height",attrs:{"fluid":""}},[_c('router-view')],1)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }